<style scoped lang="stylus" rel="stylesheet/stylus">
table
    border: 1px solid #e9e9e9
    border-collapse: collapse
    border-spacing : 0
    empty-cells : show
    th,
    td
        padding : 8px 16px
        border : 1px solid #e9e9e9
        text-align : left
    th
        background: #f7f7f7
        color : #5c6b77
        font-weight: 600
        white-space: nowrap
</style>

<template>
	<div class="container">
		<template v-if="list.length">
			<table>
				<thead>
					<tr>
						<th></th>
						<th>商品名称</th>
						<th>商品单价</th>
						<th>购买数量</th>
						<th>操作</th>
					</tr>
				</thead>
				<tbody>
					<template v-for="(item, index) in list">
						<tr :key="index">
							<td>{{ index + 1 }}</td>
							<td>{{ item.name }}</td>
							<td>{{ item.price }}</td>
							<td>
								<button @click="handleMinus(index)" :disabled="list[index].count <= 1">-</button>
								{{ item.count }}
								<button @click="handlePlus(index)">+</button>
							</td>
							<td>
								<button @click="handleRemove(index)">移除</button>
							</td>
						</tr>
					</template>
				</tbody>
			</table>
			<div>总价：￥ {{ totalPrice }}</div>
		</template>
		<div v-else>购物车为空</div>
		<tab-bar />
	</div>
</template>

<script>
import tabBar from '../../components/navigation/tab-bar'
export default {
	name: 'shoppingCart',
	components: {
		tabBar
	},
	props: {},
	data() {
		return {
			list: [
				{
					id: 1,
					name: 'iPhone 7',
					price: 6188,
					count: 1
				},
				{
					id: 2,
					name: 'iPad Pro',
					price: 5888,
					count: 1
				},
				{
					id: 3,
					name: 'MacBook Pro',
					price: 21488,
					count: 1
				}
			]
		}
	},
	filters: {},
	computed: {
		totalPrice() {
			let total = 0
			this.list.map((val, key) => {
				total += val.price * val.count
			})
			//      return total
			return total.toString().replace(/\B(?=((\d{3})+)$)/g, ',')
		}
	},
	methods: {
		handleMinus(index) {
			if (this.list[index].count > 1) {
				this.list[index].count--
			}
		},
		handlePlus(index) {
			this.list[index].count++
		},
		handleRemove(index) {
			this.list.splice(index, 1)
		}
	}
}
</script>
